import { toast } from "react-toastify";
import axios from "axios";
import store from "../../store/store"; // ✅ import the Redux store
import { logout } from "../../store/authSlice";
let sessionExpiredHandled = false;

// Set Base URL based on Environment
const isClient = typeof window !== 'undefined';
const isDevHost = isClient && window.location.host.includes('dev.');

const API_URL = isDevHost 
  ? "https://staging.servinggodschildren.com/api/v1" 
  : "https://admin.servinggodschildren.com/api/v1";

// Create Axios Instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add Request Interceptor (Inject Token)
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add Response Interceptor
apiClient.interceptors.response.use(
  (response) => {
    if (
      response?.data?.success === false &&
      response?.data?.message === "Authorization Token not found"
    ) {
      if (!sessionExpiredHandled) {
        sessionExpiredHandled = true; // ✅ block further toasts
        toast.error("Your session has expired. Please log in again.");
        store.dispatch(logout());
        setTimeout(() => {
          window.location.href = "/";
          sessionExpiredHandled = false; // ✅ reset after redirect
        }, 1500);
      }
    }

    return response.data; // ✅ always return just the data
  },
  (error) => {
    console.error("API Error:", error?.response?.data || error.message);
    toast.error(error?.response?.data?.message || "Something went wrong!");
    return Promise.reject(error);
  }
);

export default apiClient;
